import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09807420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"float":"left"} }

import { TargetActions, TargetGetters } from '@/store/modules/target';
import { UserGetters } from '@/store/modules/user';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ref, computed, reactive } from 'vue';
import { Target } from '@/store/modules/target/types';
import { UpdateTargetForm } from '@/api/target';
import { InfoFilled } from '@element-plus/icons-vue'
import { targetAPI } from '@/api/target';
import { useRoute } from "vue-router";
import { User } from '@/store/modules/user/types';
import { ElMessage } from 'element-plus'
import GenTask from '@/components/task/genTask.vue'


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "TargetListTable",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const createTargetVisible = ref<boolean>(false)
const store = useStore();
const router = useRouter();
const projectId = computed(() =>
    typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0]
);

const selectedUid = ref<string>("")
const inputUsername = ref<string>("")
const updateDialogFormVisible = ref(false);
const TargetUserDialogVisible = ref(false)
const updateTargetForm: UpdateTargetForm = reactive({
    uid: "",
    projId: "",
    description: "",
});
const dummyUid = ref<string>("")

const userinfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});

const userList = ref<User[]>([])

const targetList = computed(() => {
    return store.getters[`target/${TargetGetters.getTargetList}`];
});

const isLoading = computed(() => {
    return store.getters[`target/${TargetGetters.getLoading}`];
});

const handleDetails = (target: Target): void => {
    router.push({
        name: 'TargetDetails',
        params: { targetId: target.uid },
    });
}

const createTask = async () => {
    dummyUid.value = await targetAPI.getDummyTarget(projectId.value)
    createTargetVisible.value = true
}

const handleRefresh = async () => {
    await store.dispatch(`target/${TargetActions.asyncGetTargetList}`, projectId.value);
}

const handleDelete = async (row: Target) => {
    await store.dispatch(`target/${TargetActions.asyncDeleteTarget}`, { projId: row.projId, uid: row.uid })
}

const handleUpdate = async (row: Target) => {
    updateDialogFormVisible.value = true
    updateTargetForm.uid = row.uid
    updateTargetForm.projId = row.projId
    updateTargetForm.description = row.description
}


const updateOnSubmit = async () => {
    const updateProjectRes = await store.dispatch(`target/${TargetActions.asyncUpdateTarget}`, updateTargetForm);
    updateDialogFormVisible.value = !updateProjectRes;
}


const handleUser = async (row: Target) => {
    selectedUid.value = row.uid
    TargetUserDialogVisible.value = true
    userList.value = await targetAPI.getUsersByTarget(projectId.value, row.uid)
}

const handleCreateTargetUser = async () => {
    let username = inputUsername.value
    let uid = selectedUid.value
    let projId = projectId.value
    await targetAPI.createTargetUser(projId, uid, username)
    ElMessage({
        message: '添加成功',
        type: 'success',
    })

    inputUsername.value = ""
    userList.value = await targetAPI.getUsersByTarget(projId, uid)
}

const handleDeleteTargetUser = async (row: User) => {
    await targetAPI.deleteTargetUser(projectId.value, selectedUid.value, row.id)
    ElMessage({
        message: '删除成功',
        type: 'success',
    })
    userList.value = await targetAPI.getUsersByTarget(projectId.value, selectedUid.value)
}

const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: createTargetVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createTargetVisible).value = $event)),
      title: "新建任务",
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(GenTask, {
          projId: _unref(projectId),
          uid: dummyUid.value
        }, null, 8, ["projId", "uid"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_button, {
        style: {"float":"left","margin-left":"50px"},
        type: "primary",
        onClick: createTask
      }, {
        default: _withCtx(() => [
          _createTextVNode("新建任务")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        style: {"float":"left","margin-left":"20px"},
        type: "primary",
        onClick: handleRefresh
      }, {
        default: _withCtx(() => [
          _createTextVNode("刷新")
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _unref(targetList) }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "uid",
          label: "机器UID"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "description",
          label: "备注"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "更新时间"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(getDisplayTime(scope.row.update_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "操作"
        }, {
          default: _withCtx((scope) => [
            (_unref(userinfo) !== null && _unref(userinfo).priv !== 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => (handleUpdate(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (handleDetails(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (!scope.row.isShared && _unref(userinfo) !== null && _unref(userinfo).priv !== 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => (handleUser(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("用户")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (_unref(userinfo) !== null && _unref(userinfo).priv !== 1)
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 2,
                  width: "220",
                  "confirm-button-text": "删除",
                  "cancel-button-text": "取消",
                  title: "确定删除此台机器吗？",
                  icon: _unref(InfoFilled),
                  "icon-color": "red",
                  onConfirm: ($event: any) => (handleDelete(scope.row))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["icon", "onConfirm"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(isLoading)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: TargetUserDialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((TargetUserDialogVisible).value = $event)),
      title: "可查看此目标用户",
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_input, {
            modelValue: inputUsername.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputUsername).value = $event)),
            placeholder: "请输入用户名",
            style: {"width":"200px"}
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleCreateTargetUser
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_table, {
          data: userList.value,
          title: "有权限用户列表"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "id",
              label: "用户ID"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "username",
              label: "用户名"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              prop: "priv",
              label: "用户权限"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_popconfirm, {
                  width: "220",
                  "confirm-button-text": "删除",
                  "cancel-button-text": "取消",
                  title: "确定删除此用户共享权限？",
                  icon: _unref(InfoFilled),
                  "icon-color": "red",
                  onConfirm: ($event: any) => (handleDeleteTargetUser(scope.row))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["icon", "onConfirm"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: updateDialogFormVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((updateDialogFormVisible).value = $event)),
      title: "编辑目标机器信息",
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: updateTargetForm,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "目标UID:",
              prop: "uid"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(updateTargetForm.uid), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "所属项目:",
              prop: "projId"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(updateTargetForm.projId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "描述:",
              prop: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: updateTargetForm.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateTargetForm.description) = $event)),
                  type: "textarea",
                  placeholder: "请输入目标描述",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: updateOnSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("更新")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (updateDialogFormVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})